import React from 'react';
import { Route } from 'react-router-dom';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { RoutePathProps } from '../../../../AppRoutes/types';
import RoleList from '../pages/RoleList';
// import EditProduct from '../pages/EditProduct';

const role: RoutePathProps = {
    name: "role",
    path: "/role",
    label: "Roles",
    icon: AssignmentIndIcon,
    visibleInNav: true,
    requiredPermission:'role:list',
    children: [
        // {
        //     name: "role",
        //     path: "/role",
        //     label: "Roles",
        //     icon: AdminPanelSettingsIcon,
        // }
    ],
};

const RoleRoutes = (
    <>
        <Route path={role.path} element={<RoleList />} />
        {/* <Route path={role.children?.[0].path} element={<RoleList />} /> */}
    </>
);
export const rolePaths = [role];
export default RoleRoutes;
